import { useSelector } from 'react-redux';

import { selectModals } from 'store/layoutSlice';

import { DeleteAutomationModal } from 'containers/Automation/DeleteAutomationModal';
import { ChangeColor } from 'layout/molecules/Project/ChangeColor';
import { Invite } from 'layout/molecules/Project/Invite';
import ProjectModal from 'layout/organisms/ProjectModal/ProjectModal';

const ModalsManager = () => {
    const modals = useSelector(selectModals);
    const get = (name: string) => modals.find((m) => m.name === name);

    return (
        <>
            {get('projectDetails') && (
                <ProjectModal {...get('projectDetails')?.props} />
            )}
            {get('archivedProjectDetails') && (
                <ProjectModal
                    archived
                    {...get('archivedProjectDetails')?.props}
                />
            )}
            {get('invite') && <Invite {...get('invite')?.props} />}
            {get('changeColor') && (
                <ChangeColor {...get('changeColor')?.props} />
            )}
            {get('deleteAutomation') && (
                <DeleteAutomationModal {...get('deleteAutomation')?.props} />
            )}
        </>
    );
};

export default ModalsManager;
